import React, { useState } from 'react';
import type { Table, Order } from '../../types';

interface OrderTransferModalProps {
  sourceTable: Table;
  order: Order;
  availableTables: Table[];
  onConfirm: (targetTableId: number) => void;
  onCancel: () => void;
}

const OrderTransferModal: React.FC<OrderTransferModalProps> = ({
  sourceTable,
  order,
  availableTables,
  onConfirm,
  onCancel,
}) => {
  const [selectedTableId, setSelectedTableId] = useState<number | null>(null);

  const canTransfer = selectedTableId !== null && availableTables.length > 0;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[90vh] flex flex-col overflow-hidden my-auto">
        <header className="p-4 border-b flex-shrink-0">
          <h2 className="text-xl font-bold text-gray-800">Transfer Order</h2>
        </header>
        <main className="p-4 flex-1 min-h-0 overflow-y-auto">
          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-2">Transfer order from:</p>
            <div className="p-3 bg-gray-50 rounded border">
              <p className="font-semibold">{sourceTable.name}</p>
              <p className="text-xs text-gray-500 mt-1">
                Order ID: {order.id.substring(0, 8)}... | Items: {order.items.length}
              </p>
            </div>
          </div>

          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-2">Select target table:</p>
            {availableTables.length === 0 ? (
              <div className="p-3 bg-yellow-50 border border-yellow-200 rounded">
                <p className="text-sm text-yellow-700">No available tables found.</p>
              </div>
            ) : (
              <div className="max-h-60 overflow-y-auto space-y-2">
                {availableTables.map(table => (
                  <button
                    key={table.id}
                    onClick={() => setSelectedTableId(table.id)}
                    className={`w-full p-3 text-left rounded border transition-colors ${
                      selectedTableId === table.id
                        ? 'bg-blue-100 border-blue-400'
                        : 'bg-gray-50 border-gray-200 hover:bg-gray-100'
                    }`}
                  >
                    <p className="font-semibold">{table.name}</p>
                    <p className="text-xs text-gray-500">Capacity: {table.capacity}</p>
                  </button>
                ))}
              </div>
            )}
          </div>
        </main>
        <footer className="p-4 border-t flex justify-end gap-2 flex-shrink-0">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => selectedTableId && onConfirm(selectedTableId)}
            disabled={!canTransfer}
            className={`px-4 py-2 text-white rounded transition-colors ${
              canTransfer
                ? 'bg-blue-500 hover:bg-blue-600'
                : 'bg-gray-300 cursor-not-allowed'
            }`}
          >
            Transfer Order
          </button>
        </footer>
      </div>
    </div>
  );
};

export default OrderTransferModal;

